import {
  CREATE_DESIGN,
  CREATE_DESIGN_FAILED,
  UPDATE_ITEM_PRODUCT,
  UPDATE_ITEM_PRODUCT_FAILED,
  GET_DESIGN_BY_ITEM,
  GET_DESIGN_BY_ITEM_FAILED,
  ENABLE_SAVE,
  DISABLE_SAVE,
  SAVE_CONFIG_START,
  SAVE_CONFIG_SUCCESS,
  SAVE_CONFIG_FAILED,
  SAVE_ONLINE_DESIGN_SUCCESS,
  SAVE_ONLINE_DESIGN_FAILED,
  SEND_DESIGN_EMAIL_SUCCESS,
  SEND_DESIGN_EMAIL_FAILED,
} from '../actions/actionTypes';

// Must be a pure function that requires the state
// and the action being dispatched.
const initialState = {
  currentDesign: {},
  currentItem: {},
  errors: { designApiError: false },
  isSaveEnabled: true,
  configurationSaved: false,
  designAssociated: false,
  emailSent: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
  // NEVER mutate the state, always return a new state.

  case CREATE_DESIGN:
  {
    const currentDesign = action.payload.design;
    const currentItem = action.payload.items[0];

    return {
      ...state,
      currentDesign,
      currentItem,
    };
  }

  case GET_DESIGN_BY_ITEM: {
    return {
      ...state,
      ...action.payload,
    };
  }

  case UPDATE_ITEM_PRODUCT: {
    const currentItem = action.payload.items[0];
    return {
      ...state,
      currentItem,
    };
  }

  case CREATE_DESIGN_FAILED:
  case UPDATE_ITEM_PRODUCT_FAILED:
  case GET_DESIGN_BY_ITEM_FAILED: {
    return {
      ...state,
      errors: {
        designApiError: true,
        message: action.payload ? action.payload.message : '',
        messageDetail: action.payload ? action.payload.messageDetail : '',
      },
    };
  }

  case ENABLE_SAVE: {
    return {
      ...state,
      isSaveEnabled: true,
    };
  }

  case DISABLE_SAVE: {
    return {
      ...state,
      isSaveEnabled: false,
    };
  }

  case SAVE_CONFIG_START: {
    return {
      ...state,
      isSaving: true,
    };
  }

  case SAVE_CONFIG_SUCCESS: {
    return {
      ...state,
      isSaving: false,
      isSaveEnabled: false,
      configurationSaved: true,
    };
  }

  case SAVE_CONFIG_FAILED: {
    return {
      ...state,
      isSaving: false,
      isSaveEnabled: true,
      configurationSaved: false,
    };
  }

  case SAVE_ONLINE_DESIGN_SUCCESS: {
    return {
      ...state,
      designAssociated: true,
    };
  }

  case SAVE_ONLINE_DESIGN_FAILED: {
    return {
      ...state,
      designAssociated: false,
      isSaveEnabled: true,
      isSaving: false,
    };
  }
  case SEND_DESIGN_EMAIL_SUCCESS: {
    return {
      ...state,
      emailSent: true,
      isSaving: false,
    };
  }
  case SEND_DESIGN_EMAIL_FAILED: {
    return {
      ...state,
      emailSent: false,
      isSaveEnabled: true,
      isSaving: false,
    };
  }

  default:
    return state;
  }
};
